export default __webpack_public_path__ + "static/media/sounds/trcComprehensionReady.mp3";